module.exports = __webpack_public_path__ + "img/landliebe-6415.4aaa47ff.jpeg";